//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

/**
 * Second pass rescoring type
 */
export enum SecondPassRescoringMode {
    None = "None",
    Voice = "Voice",
    Dictation = "Dictation",
    Conversation = "Conversation"
}
